import React from 'react';

import Modal from '@material-ui/core/Modal';

import classes from './TermsAndConditions.module.css';
import { agreement } from './BOBSaaSAgreement.js';
import { fullYear } from '../../utils/date-util';

const TermsAndCondition = props => {
    return (
        <Modal open={props.open} onClose={props.handleClose}>
            <div className={classes.TermsConditions}>
                <img src={'/assets/images/BOB-BLACK.png'} alt="BOB Logo" />
                <h1>WennSoft&reg;</h1>
                <h2>Terms and Conditions</h2>
                <Copyright />
                <Section section={agreement()} />
            </div>
        </Modal>
    );
};

const Copyright = () => {
    return (
        <React.Fragment>
            <h3>Copyright</h3>
            <div>Copyright &copy; {fullYear()} WennSoft, Inc. All rights reserved.</div>
        </React.Fragment>
    );
};

const Section = ({
    section,
    level = 0,
    idx = 0,
}) => {
    const styles = {
        paddingLeft: `${level}rem`
    };

    return (
        <div key={`${level}-${idx}`} style={styles}>
            {section.name && <span className={classes.name}>{section.name}</span>}
            {section.title && <span className={classes.title}>{section.title}</span>}
            <span>{section.description}</span>
            <Sections sections={section.sections} level={level + 1} />
        </div>
    );
};

const Sections = ({
    sections,
    level
}) => {
    if (!sections) return '';

    return sections.map((section, idx) =>
        <Section
            key={idx}
            section={section}
            level={level}
            idx={idx}
        />
    );
};

export default TermsAndCondition;
export {Section, Sections};
